import { FC } from "react";
import { useSectionNavigationContext } from "../section-navigation-context";

const SectionNavigationListItemContent: FC = ({ children, ...rest }) => {
  const { getBlocksWith } = useSectionNavigationContext();

  if (!getBlocksWith) {
    throw new Error(
      "SectionNavigation component requires a class builder to be defined",
    );
  }

  return (
    <div className={getBlocksWith("__list-item-content")} {...rest}>
      {children}
    </div>
  );
};

export default SectionNavigationListItemContent;
